
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MenuItem, SortEvent } from 'primeng/api';
import { DepartmentService } from './department.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { GlobalMessage, Viewdata, Departments, Groups } from '../../utility/modals';
import { DepartmentmodalComponent } from '../../directives/departmentmodal/departmentmodal.component';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { BulkexceluploadComponent } from '../../directives/bulkexcelupload/bulkexcelupload.component';
@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css']
})

export class DepartmentComponent implements OnInit {
  @ViewChild('dt') dt: any;
  departmentForm: FormGroup
  selectedItem: MenuItem | null = null;
  tableData: any[] = [];
  isDropdownOpen = false;
  excel_paragraph = '';
  templatedownloadtext = '';
  exceldownloadModal = false;
  downloadformate = false;
  searchText: string;
  departmentlist: any;
  departmentlistarray: Array<Departments> = [];
  sortOrder = 1;
  sortProperty: string = 'id';
  departmentRequest: Departments = new Departments();
  departmentUpdatereq: Departments = new Departments();
  groups: any;
  groupsarray: Array<Groups>;
  departmenttype: any;
  departypearray: Array<Departments> = [];
  dataview: Viewdata = new Viewdata();
  ref: DynamicDialogRef | undefined;
  deptlist: Array<any>;
  buttunText = "Add New"
  isButtonraised: boolean = true;
  commonScrollHeight = '';
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 20, 50, 100];
  tablecount: number = 0;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  selectedProduct = false;
  options = [];
  paginatorArray
  CSRFToken = '';
  visible: boolean = false;
  psition = 'top';
  cols = [];
  _selectedColumns = [];
  bulkModal = false;
  message: GlobalMessage = new GlobalMessage();
  sortfield: string = 'departmentname';
  sortorder = 1;
  currentPageIndex: number = 0;
  rowsize: number = 10;
  inactiveModal = false;
  parentdata: any;
  searchTerm: string = ''; 
  isSupportAdmin = "N";
  hasLimitedAccess = "";
  userRole = "";
  tssprtlimitedaccess = "N";

  constructor(
    private deptService: DepartmentService,
    public router: Router, private fb: FormBuilder,
    public dialogService: DialogService, public utilityservice: Utilityservice, public PagehelpmodalService: PagehelpmodalService) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text
  }
  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.getdepartments();
    this.getConfiguration();
    this.formInitialized();
    this.dynamiccols();
   // this.gettoken();

  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }

  dynamiccols() {
    this.cols = [
      { field: 'departmentid', header: 'Department ID', type: 'Number', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: "departmentname", header: "Department Name", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "deptinitial", header: "Department Initial", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdby", header: "Created By", type: 'date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdon", header: "Created On", type: 'date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "activeflag", header: "Status", type: 'text', sort: false, filter: false, width: '20px', isChecked: true, class: 'otherheader' }
    ]
    this._selectedColumns = this.cols;
  }


  getdepartments() {
    //this.spinner.show();
    const currentPageSize = this.rowsize;

    this.deptService.getDepartmentData().subscribe({
      next: (data: any) => {
        //this.spinner.hide();
        this.departmentlist = data;
        this.departmentlistarray = data.map((item: any) => ({ ...item, isSelect: false }));

        this.options = this.deptService.getOptionDropdown(data.length);
        this.paginatorArray = this.options.map((e) => e.value);

        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.rowsize = currentPageSize;
        this.totalRecords = this.departmentlistarray.length;
        this.tablecount = data.count ?? data.length;

        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);
      },
      error: (error) => {
        //this.spinner.hide();
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || "Error",
          text: `This error occurred at: ${timestamp}`,
          icon: "error",
        });
      },
    });
  }

  show(title, data) {
    let details = {}
    if (title === 'Modify Department') {
      this.deptService.getDepartmentById(data.departmentid).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(DepartmentmodalComponent, {
          header: title,
          width: '50vw',
          height: 'auto',
          data: { title: title, datas: details },
          contentStyle: { overflow: 'hidden' },

        });
        this.ref.onClose.subscribe(() => {
          this.getdepartments();
          this.gettoken();
        });
      })
    } else {
      details = {}
      this.ref = this.dialogService.open(DepartmentmodalComponent, {
        header: title,
        width: '50vw',
        height: 'auto',
        data: { title: title, datas: details },
        contentStyle: { overflow: 'hidden' },
      });
      this.ref.onClose.subscribe(() => {
        this.getdepartments();
        this.gettoken();
        
      });
    }
  }

  //Download Department Upload Format Excel
  excelUploadFormat() {
    this.deptService.excelUploadFormat().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Department_Data_Format.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.downloadformate = false;
      Swal.fire('File downloaded successfully!', '', 'success');
    }, error => {
      Swal.fire('Something went wrong', '', 'error');

    })
      ;
  }
  showDialog() {
    let payload = {}
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: width,
      height: '10rem',
      data: { excelname: "Department_Master_Data.xlsx", downloadapi: 'common/department/departmentDataExcel', method: 'get', message: this.excel_paragraph, payload: payload },
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
    });
  }
  //Get Department by Id
  tempuse: any;
  getdepartment() {
    this.deptService.getDepartmentData().subscribe((data) => {
      this.departmentlist = data;
      this.departmentlistarray = this.departmentlist;
      this.tablecount = this.departmentlist.count;
      this.options = this.deptService.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value)
    });
  }


  formInitialized() {
    this.departmentForm = this.fb.group({
      processname: [''],
      departmentid: [''],
      activeflag: ['Y']
    })
  }
  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }
  filedata: any = []
  setEvent(event) {
    this.filedata = event

  }
  customSort(event: SortEvent) {
    console.log(event, "sort event");
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;

      // Handle null values
      if (value1 == null && value2 == null) return 0; // Both are null
      if (value1 == null) return event.order === 1 ? 1 : -1; // value1 is null
      if (value2 == null) return event.order === 1 ? -1 : 1; // value2 is null

      // Determine result based on field type
      if (typeof value1 === 'string' && typeof value2 === 'string') {
        if (event.field === 'createdon') {
          // Parse date strings into Date objects
          const date1 = new Date(value1.split('-').reverse().join(',')); // Convert "DD-MMM-YYYY" to "YYYY,MMM,DD"
          const date2 = new Date(value2.split('-').reverse().join(','));
          result = date1.getTime() - date2.getTime(); // Compare timestamps
        } else {
          // Handle departmentname and other strings
          if (event.field === 'departmentname') {
            result = value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
          } else {
            result = value1.localeCompare(value2);
          }
        }
      } else if (typeof value1 === 'number' && typeof value2 === 'number') {
        // Numeric comparison
        result = value1 - value2;
      } else {
        // Fallback for mixed types or unexpected cases
        result = value1.toString().localeCompare(value2.toString());
      }

      return event.order === 1 ? result : -result;  // Adjust for ascending/descending order
    });
  }



  openexceluploadmodal() {
    if(this.hasLimitedAccess == "Y")
    {
      return;
    }

    let payload = {}
    this.parentdata = {};
    this.parentdata = {
      title: 'Department Data Upload',
      apdownloadapi: 'common/department/uploadExcel', 
      sucessmessage: 'Department Data uploaded successfully!',
      master: 'Department',
      message:`You should have downloaded the Excel format for department creation. You should have updated all the required information. The Excel file you choose will be uploaded and verified for accuracy. If there are no errors, the hierarchies will be created. Else, the errors will be displayed on the screen.`
    }
    this.ref = this.dialogService.open(BulkexceluploadComponent, {
      header: this.parentdata.title,
      width: '70%',
      height: '40',
      data: {
        uploadapi: this.parentdata.apdownloadapi,
        method: 'Post', message: this.parentdata.message, payload: payload,master: this.parentdata.master
      },
      contentStyle: { overflow: 'hidden' },
      position: 'center',
      style: { 'max-width': '100%', 'min-width': '60%' }
    }),
      this.ref.onClose.subscribe(res => {
        if (res == 'uploaded') {
          this.getdepartments();
        }
      })
  }



  fileupload() {
    const formData = new FormData();
    formData.append("file", this.filedata[0]);

    // Check if the uploaded file is empty
    if (this.filedata[0] === null || this.filedata[0] === undefined || this.filedata[0].length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Uploaded file is empty'
      });
      return;
    }

    // Validate file format
    const fileName = this.filedata[0].name;
    if (!fileName.toLowerCase().endsWith('.xlsx')) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Invalid file format. Please upload an Excel (.xlsx) file'
      });
      return;
    }
    this.deptService.bulkUpload(formData).subscribe(
      res => {
        Swal.fire({
          icon: 'success',
          title: 'Saved!',
          text: ''
        }).then(result => {
          this.getdepartment();
          this.bulkModal = false;
        });
      },
      error => {
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong',
          text: ''
        });
      }
    );
  }


  handleDialogClose() {
    this.filedata = [];
  }
  getselectfiles(event) {
    this.filedata = event
  }

  getConfiguration(): void {
    this.deptService.getConfiguration().subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.isSupportAdmin = response[0]?.isSupportAdmin || 'N';
          this.userRole = response[0]?.userRole;
          this.hasLimitedAccess = response[0]?.haslimitedaccess || 'N';
          if (this.hasLimitedAccess == "Y" && this.isSupportAdmin == "Y") {
            this.tssprtlimitedaccess = "Y";
          }
        }
      },
      (error) => {
        console.error('Error fetching configuration:', error);
      }
    );
  }
  departmentId: number;
  selectedDepartmentName: string = "";
  openInactiveModal(data) {
    this.departmentId = data.departmentid;
    this.selectedDepartmentName = data.departmentname;
    this.inactiveModal = true;
    this.gettoken();

  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }

  inactivateDepartment(departmentId: any) {
    const payload = {
      departmentId: departmentId,
      csrftoken: this.CSRFToken,
    };

    this.deptService.inactivateDepartment(payload).subscribe({
      next: (response: any) => {
        const code = response?.response;

        switch (code) {
          case '0':
            Swal.fire('Department inactivated successfully!', '', 'success').then(() => {
              this.inactiveModal = false;
              this.getdepartments();
            });
            break;
          case '1':
            Swal.fire('The ' + this.selectedDepartmentName + ' department cannot be inactivated, as there are active compliances associated with this department.', '', 'error');
            break;
          case '2':
            Swal.fire('The ' + this.selectedDepartmentName + ' department cannot be inactivated, as there are active controls associated with this department.', '', 'error');
            break;
          case '3':
            Swal.fire('The ' + this.selectedDepartmentName + ' department cannot be inactivated, as there are active compliances and controls associated with this department.', '', 'error');
            break;
          default:
            Swal.fire('Error', 'An unexpected error occurred.', 'error');
            break;
        }
      },
      error: (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.error?.response || 'An unexpected error occurred.',
          footer: `Error status: ${error.status}`
        });
      }
    });
  }
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }
}



